var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccessoriRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-914 3832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,530.46H2v-2.667a1.333,1.333,0,0,1,1.333-1.333H20.667A1.333,1.333,0,0,1,22,527.793Z",
    transform: "translate(914 -4355)",
    fill: "#d22a16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,530.46H2v-2.667a1.333,1.333,0,0,1,1.333-1.333H20.667A1.333,1.333,0,0,1,22,527.793Z",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,543.793H4a.667.667,0,0,1-.667-.667V530.46H20.667v12.666a.667.667,0,0,1-.667.667",
    transform: "translate(914 -4355)",
    fill: "#d22a16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,543.793H4a.667.667,0,0,1-.667-.667V530.46H20.667v12.666A.667.667,0,0,1,20,543.793Z",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 11,
    transform: "translate(924 -3828.54)",
    fill: "#d22a16"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 11,
    transform: "translate(924 -3828.54)",
    fill: "none",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(914 -3832)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessoriRed);
export default __webpack_public_path__ + "static/media/accessori_red.ebb24caed5252b555fb556b280df264e.svg";
export { ForwardRef as ReactComponent };